import { useCompanyOnboarding } from './useCompanyOnboarding';
import { useUserOnboardingStatus } from './useUserOnboardingStatus';

export interface OnboardingGuardState {
  isLoading: boolean;
  error: string | null;
  needsUserOnboarding: boolean;
  needsCompanyOnboarding: boolean;
  isFullyOnboarded: boolean;
  canAccessApp: boolean;
}

export function useOnboardingGuard(): OnboardingGuardState {
  const {
    isLoading: companyLoading,
    error: companyError,
    needsCompanyOnboarding,
    isCompanyOnboardingComplete,
    hasCompanyConnection
  } = useCompanyOnboarding();

  const {
    isLoading: userLoading,
    error: userError,
    needsUserOnboarding,
    isUserOnboardingComplete,
    status
  } = useUserOnboardingStatus();

  const isDataReady = hasCompanyConnection !== null && status !== null;
  const isLoading = companyLoading || userLoading || !isDataReady;
  const error = companyError || userError;

  // Company onboarding takes priority - check it first
  const isFullyOnboarded = isCompanyOnboardingComplete && isUserOnboardingComplete;
  const canAccessApp = isFullyOnboarded;

  return {
    isLoading,
    error,
    needsUserOnboarding: !isCompanyOnboardingComplete ? false : needsUserOnboarding,
    needsCompanyOnboarding,
    isFullyOnboarded,
    canAccessApp
  };
}